var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isCurrentUserLoaded)?_c('v-btn',{attrs:{"text":""}},[_c('v-icon',{staticClass:"pr-1"},[_vm._v("mdi-account-box")]),_vm._v(" "+_vm._s(_vm.currentUser.name)+" ")],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }